import { AUTH_TYPE, AuthType } from "../Enums";

export class Credential implements ICredential {
  constructor(
    public authType: AuthType = 0 // Default to None
  ) {}
}

export class BasicCredential extends Credential implements IBasicCredential {
  constructor(
    public username: string,
    public password: string
  ) {
    super(AUTH_TYPE.basic);
  }
}

export class ApiKeyCredential extends Credential implements IApiKeyCredential {
  constructor(
    public apiKey: string
  ) {
    super(AUTH_TYPE.apiKey);
  }
}

export class OAuth2Credential extends Credential implements IOAuth2Credential {
  constructor(
    public clientId: string,
    public clientSecret: string,
    public refreshToken: string,
    public refreshTokenCreatedAt: Date,
    public refreshTokenExpiresAt: Date,
    public refreshTokenRevokedAt?: Date
  ) {
    super(AUTH_TYPE.oauth2);
  }
}

export class BasicTimeBasedCredential extends Credential implements IBasicTimeBasedCredential {
  constructor(
    public username: string,
    public password: string,
    public oneTimeAccount: string,
    public oneTimeAccountSecret: string | undefined = undefined,
  ) {
    super(AUTH_TYPE.basicTimeBased);
  }
  public authenticatorCode: string = '';
}

export class UserLinkedService implements IUserLinkedService {
  constructor(
    public id: number,
    public tenantId: number,
    public userId: number,
    public linkedServiceId: string,
    public endpointUrl: string,
    public credentials: BasicCredential | ApiKeyCredential | OAuth2Credential | BasicTimeBasedCredential
  ) { }
}

export interface ICredential {
  authType: AuthType;
}

export interface IBasicCredential extends ICredential {
  username: string;
  password: string;
}

export interface IApiKeyCredential extends ICredential {
  apiKey: string;
}

export interface IOAuth2Credential extends ICredential {
  clientId: string;
  clientSecret: string;
  refreshToken: string;
  refreshTokenCreatedAt: Date;
  refreshTokenExpiresAt: Date;
  refreshTokenRevokedAt?: Date;
}

export interface IBasicTimeBasedCredential extends ICredential {
  username: string;
  password: string;
  oneTimeAccount: string;
  oneTimeAccountSecret: string | undefined;
}

export default interface IUserLinkedService {
  id: number;
  tenantId: number;
  userId: number;
  linkedServiceId: string;
  endpointUrl: string;
  credentials: IBasicCredential | IApiKeyCredential | IOAuth2Credential | IBasicTimeBasedCredential;
}
